import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { L10nLocale, L10nTranslationService, L10N_LOCALE } from 'angular-l10n';
import { loadMessages, locale } from 'devextreme/localization';
import messagesHu from 'devextreme/localization/messages/hu.json';
import notify from 'devextreme/ui/notify';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CodesFunc, CodeWarehouseEditModel } from 'src/app/services/codes.service';

import { LoginUser, PatientDataViewModel } from 'src/app/services/webapiclient.service';
import { PatientService } from '../patient.service';

  /**
   * Nem használjuk.
   * Addikciókat a patient-details komponensben kezeljük
   */

@Component({
    selector: 'app-patient-addictions',
    templateUrl: './patient-addictions.component.html',
    styleUrls: ['./patient-addictions.component.scss'],
    standalone: false
})
export class PatientAddictionsComponent implements OnInit {

  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  code: string;
  regularitySource: any;
  smokingOptions: any[];
  alcoholOptions: any[];
 
  patientDataViewModel: PatientDataViewModel = {} as PatientDataViewModel;

  currentUser: LoginUser;
 
  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
     private route: ActivatedRoute,
     private translation: L10nTranslationService,
     private authenticationService: AuthenticationService,
     private patientService: PatientService,
     private codesFunc: CodesFunc
 
  ) {
    const huMessages = JSON.stringify(messagesHu['hu']);
    loadMessages({
     'hu': JSON.parse(huMessages)
    });
     this.smokingOptions = [
      {text: this.translation.translate('Project.DoNotSmoking'), value: false}, 
      {text: this.translation.translate('Project.DoSmoking'), value: true}
    ];
    this.alcoholOptions = [
      {text: this.translation.translate('Project.NotConsumeAlcohol'), value: false}, 
      {text: this.translation.translate('Project.ConsumeAlcohol'), value: true}
    ];
  }

  ngOnInit(): void {
        this.translation.onChange().subscribe(x=>{ 
          locale(x.language);
        });
        this.code = this.route.snapshot.paramMap.get('code');
   
        this.currentUser = this.authenticationService.currentUserValue;
        if(this.currentUser){
          this.getPatientData(this.currentUser.id);
        }
        this.loadCodesSources();

     // get return url from route parameters or default to '/'
     this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }
  loadCodesSources(){
    this.codesFunc.getCodesData('Frequency').then(
      result => {
        this.regularitySource = <CodeWarehouseEditModel[]> result;
       }
      ).catch(err => {
          this.error = err;
    }); 
   }

  onFormSubmit = function(e) {
    this.error = ""; 
    this.loading = true;
    this.patientDataViewModel.patientDataId = this.currentUser.id;

     //let result: any;
     this.patientService.updatePatient(this.currentUser.id,JSON.stringify(this.patientDataViewModel)).then(
      result => {
        if(result == "OK"){
          notify({
             message: "Sikeres mentés!",
             position: {
                 my: "center top",
                 at: "center top"
             }
         }, "success", 3000);

          //this.router.navigate(['/login']);
        }else{
          this.error = result;
          this.loading = false;
         }
        }
      ).catch(err => {
          this.error = err;
          this.loading = false;
      });
        
      e.preventDefault();
    }

  
 
  getPatientData(id: string){
    this.loading = true;
    this.patientService.getPatient(id).then(
        result => {
          this.patientDataViewModel = <PatientDataViewModel> result;
             this.loading = false;
         }
    ).catch(err => {
        this.error = err;
        this.loading = false;
   });
    }

}
